import React from 'react';
import PropTypes from 'prop-types';
import MainGridMiddleRightRowDayOnTypeSlot from './MainGridMiddleRightRowDayOnTypeSlot';

/**
 * MainGridMiddleRightDayOnTypeSlot
 */
class MainGridMiddleRightDayOnTypeSlot extends React.Component {

  render() {
    const actions = this.props.actions;
    let MainGridNodes = this.props.dataDayOn.map((maingrid, index) => {
      let cnt = index + 1;
      maingrid['cnt'] = cnt;
      return (
        <MainGridMiddleRightRowDayOnTypeSlot dataDayOnItem={maingrid} actions={actions} key={index} />
      );
    });
    return (
      <div className="ledger_sheet_scroll return_x return_y ib bar bar_xy" style={{ width: 'auto', height: '100%' }} onScroll={e => this.props.actions.onScroll(e.target)}>
        <div className="ledger_sheet_scroll_inner scroll_x max_height_target max_height_day row_width_day">
          <div className="modlue center_col ib textright grid_line_bottom">
            {MainGridNodes}
          </div>
        </div>
      </div>
    );
  }
}

MainGridMiddleRightDayOnTypeSlot.propTypes = {
  dataDayOn: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
};

export default MainGridMiddleRightDayOnTypeSlot;
